import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const createProducerTag = createAsyncThunk(
  "producerTags/createProducerTag",
  async ({ token, payload }) => {
    const response = await api.post("/producer-tags", { ...payload }, { token });
    return response.data;
  }
);

export const getAllProducerTags = createAsyncThunk(
  "producerTags/getAllProducerTags",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/producer-tags", {
      token,
      params: queryParams,
    });
    return response.data;
  }
);

export const updateProducerTag = createAsyncThunk(
  "producerTags/updateProducerTag",
  async ({ token, id, payload }) => {
    const response = await api.patch(`/producer-tags/${id}`, { ...payload }, { token });
    return response.data;
  }
);

export const deleteProducerTag = createAsyncThunk(
  "producerTags/deleteProducerTag",
  async ({ token, id }) => {
    const response = await api.delete(`/producer-tags/${id}`, { token });
    return response.data;
  }
);

export const getProducerTagById = createAsyncThunk(
  "producerTags/getProducerTagById",
  async ({ token, id }) => {
    const response = await api.get(`/producer-tags/${id}`, { token });
    return response.data;
  }
);

export const getAllProducerTagsWithoutPagination = createAsyncThunk(
  "producerTags/getAllProducerTagsWithoutPagination",
  async ({ token }) => {
    const response = await api.get("/producer-tags/all/ignore-Pagination", { token });
    return response.data;
  }
);

export const updateAllProducerTagUsageCounts = createAsyncThunk(
  "producerTags/updateAllProducerTagUsageCounts",
  async ({ token }) => {
    const response = await api.post("/producer-tags/update-used-in", {}, { token });
    return response.data;
  }
);

export const mostUsedProducerTags = createAsyncThunk(
  "producerTags/mostUsedProducerTags",
  async () => {
    const response = await api.get("/producer-tags/fetchTopTags");
    return response.data;
  }
);

export const getProducerTagIdByTagName = createAsyncThunk(
  "producerTags/getProducerTagIdByTagName",
  async ({ tagName }) => {
    const response = await api.get(`/producer-tags/getTagIdByTagName`, { params: { tagName } });
    return response.data;
  }
);

export const getPacksByProducerTag = createAsyncThunk(
  "producerTags/getPacksByProducerTag",
  async ({ token, id }) => {
    const response = await api.get(`/producer-tags/packsByTag/${id}`, { token });
    return response.data;
  }
);
